import { Global, useTheme } from "@emotion/react";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { SwipeUp } from "@mui/icons-material";
import { CssBaseline, GlobalStyles, Stack, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { selectSwipeEdge, toggleSwipe } from "../features/Search/searchSlice";
import { Box } from "@mui/material";
import React, { useEffect, useLayoutEffect, useRef } from "react";
import zIndex from "@mui/material/styles/zIndex";

const StyledBox = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.mode === "light" ? "#fff" : grey[800],
}));

const Puller = styled("div")(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: theme.palette.mode === "light" ? grey[300] : grey[900],
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 15px)",
}));

const SwipeEdge = ({ sx = {}, height = "calc(100vh - 145px)", content, drawerBleeding = 60, title }) => {
  const open = useSelector(selectSwipeEdge);
  const theme = useTheme();
  const dispatch = useDispatch();
  const toggleDrawer = (newOpen) => () => {
    dispatch(toggleSwipe({ value: newOpen }));
  };
  const handleToggleOpen = () => {
    console.log("swipe opened");
    dispatch(toggleSwipe({ value: true }));
    window["ReactNativeWebView"] &&
      window["ReactNativeWebView"]?.postMessage(JSON.stringify({ type: "swipe", value: true }));
  };
  const handleToggleClose = () => {
    dispatch(toggleSwipe({ value: false }));
    window["ReactNativeWebView"] &&
      window["ReactNativeWebView"]?.postMessage(JSON.stringify({ type: "swipe", value: false }));
  };
  useEffect(() => {
    // Handle messages from React Native
    const handleMessage = (event) => {
      if (event.data === "closeSwipe" && open) {
        handleToggleClose();
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [open, handleToggleClose]);

  return (
    <>
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: height,

            // height: `calc(50% - ${drawerBleeding}px)`,
            overflow: "visible",
            display: "block",
            [theme.breakpoints.down("lg")]: {
              display: "block",
              ...sx,
            },
          },
        }}
      />
      <SwipeableDrawer
        id="swipe"
        anchor="bottom"
        open={open}
        onClose={handleToggleClose}
        onOpen={handleToggleOpen}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <StyledBox
          sx={{
            position: "absolute",
            top: -drawerBleeding + 4,
            borderTopLeftRadius: 15,
            borderTopRightRadius: 15,
            visibility: "visible",
            right: 0,
            left: 0,
            border: 1,
            borderColor: "divider",
            ...(drawerBleeding === 0 && { top: open ? -56 : 0 }),
          }}
        >
          <Puller />
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"center"}
            // sx={{ ...(drawerBleeding === 0 ? { display: 'none' } : { display: 'flex' }) }}
          >
            <SwipeUp />
            <Typography sx={{ p: 2, color: "text.secondary", textAlign: "center" }}>{title}</Typography>
          </Stack>
        </StyledBox>
        <StyledBox
          sx={{
            px: 2,
            pb: 2,
            height: "100%",
            overflow: "auto",
            ...sx,
          }}
        >
          {content}
        </StyledBox>
      </SwipeableDrawer>
    </>
  );
};

export default SwipeEdge;
